import * as React from 'react'
import I18n from '../../../../core/i18n'
import { adminService } from '../../../../core/services'
import { InputText, InputFile } from '../../../atoms'
import AdminLayoutNew from '../_layouts/new'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

const FIELDS = {
  name: 'name',
  name_ja: 'name_ja',
  position: 'position',
}

const title = I18n.t('admin.create_new', {
  model: I18n.t('area', { scope: 'activerecord.models' }),
})

const AdminAreaNew: React.FC<{}> = props => {
  const [image, setImage] = React.useState(null)
  const handleSubmit = React.useCallback(
    async (initialValues, values) => {
      const formData = new FormData()
      Object.keys(values).forEach(key => {
        formData.append(`area[${key}]`, values[key])
      })
      if (image) {
        formData.append('area[image]', image)
      }
      const { createdArea, flush } = await adminService.createArea(formData)
      window.flashMessages.addMessage({ text: flush.message, type: flush.type })
      location.href = '/admin/areas'
    },
    [image]
  )

  return (
    <AdminLayoutNew
      model="area"
      title={title}
      fields={FIELDS}
      indexLink="/admin/areas"
      formItems={
        <>
          <InputText required={true} name="name" defaultValue="" label={I18n.t('generic.name')} />
          <InputText
            required={false}
            name="name_ja"
            defaultValue=""
            label={I18n.t('generic.name_ja')}
          />
          <InputText
            required={true}
            name="position"
            defaultValue=""
            label={I18n.t('generic.position')}
          />
          <InputFile
            name="image"
            onChangeHandler={event => {
              setImage(event.currentTarget.files[0])
            }}
            label={I18n.t('generic.image')}
          />
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default AdminAreaNew
